<template>
    <div class="modal-full">
        <div class="modal-header">
            <close-icon v-on:click="closeView"></close-icon>
            <h1>Edit Account Group</h1>
        </div>

        <div class="modal-body no-pad" v-if="group">
            <div class="flex h-full">
                <div class="account-sidebar h-full">
                    <div class="mb-4 text-center">
                        <span class="fa-layers fa-4x mb-3">
                            <i class="fa fa-circle"></i>
                            <i class="fas fa-users fa-inverse" data-fa-transform="shrink-6.5"></i>
                        </span>

                        <p class="text-lg font-light"></p>
                    </div>

                    <div class="mb-3">
                        <label>ID</label>
                        <p>{{ group.id }}</p>

                        <label>GID</label>
                        <p>{{ group.gid }}</p>

                        <label>Members</label>
                        <p><a href="#" @click.prevent="handleViewUsers">{{ group.accounts_count }}</a></p>

                        <label>Flags</label>
                        <p>{{ group.flags_count }}</p>
                        <p><a href="#" @click.prevent="showFlagsView">Manage</a></p>
                    </div>
                </div>

                <div class="account-body">
                    <form class="profile-form">
                        <div class="form-field">
                            <input type="text" v-model="group.name">
                            <label>Name</label>
                        </div>

                        <div class="form-field mb-4">
                            <textarea rows="3" v-model="group.description"></textarea>
                            <label>Description</label>
                        </div>

                        <div class="form-field">
                            <input type="text" v-model="groupPromo">
                            <label>Auto-apply promotion code</label>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <div class="modal-footer">
            <div class="flex">
                <div class="left text-left">
                    <button class="btn-danger muted" type="button" @click="handleDelete" v-if="group">Delete</button>
                </div>

                <div class="right text-right">
                    <button class="btn-tertiary muted" type="button" @click="closeView">Close</button>
                    <button class="btn-primary" type="button" @click="saveForm">Save</button>
                </div>
            </div>
        </div>
        <router-view v-slot="{ Component }">
            <transition name="drop-in" mode="in-out">
                <component :is="Component"></component>
            </transition>
        </router-view>
    </div>
</template>

<script>
export default {
    name: 'AccountGroupsView',
    props: {
        //
    },
    components: {
        //
    },
    data() {
        return {
            group: null,
            groupPromo: null,
        }
    },
    mounted() {
        this.loadData()

        this.setMetaTitle('Edit Account Group | JournoLink Control')
    },
    beforeDestroy() {
        //
    },
    beforeRouteUpdate(to, from, next) {
        this.$route.params.id = to.params.id
        this.loadData()
        next()
    },
    methods: {
        loadData() {
            axios.get(route('accountGroups.show', this.$route.params.id))
                .then(response => {
                    this.group = response.data.accountGroup
                    this.groupPromo = this.group.flags?.active_promotion || null
                    this.setMetaTitle('Edit Account Group | JournoLink Control')
                })
                .catch(e => {
                    console.error({e})
                })
        },
        /**
         * Emit the close event to the parent
         *
         * @return {void}
         */
        closeView() {
            this.$root.goBack()
        },
        /**
         *
         */
        saveForm() {
            axios.put(route('accountGroups.update', this.$route.params.id), this.group)
                .then(response => {
                    this.updatePromoFlagValue()
                        .then(response => {
                            this.group = response.data.accountGroup
                            this.groupPromoValue = null
                            this.$bus.$emit('alert.success', 'Account Group has been saved')
                        })
                })
                .catch(e => {
                    console.error({e})
                })
        },

        updatePromoFlagValue() {
            return axios.post(route('accountGroups.flags', this.$route.params.id), {
                flags: this.getFlagsToSavePromoValue(),
            })
        },

        /**
         * Build the payload to update the active_promotion flag field.
         *
         * @return {Object}
         */
        getFlagsToSavePromoValue() {
            let flags = this.group.flags.length > 0 ? this.group.flags : {}
            flags['active_promotion'] = this.groupPromo
            return flags
        },

        /**
         * Handle a button-press to delete the Group
         *
         * @return {Object}
         */
        handleDelete() {
            this.alert.fire({
                title: 'Are you sure?',
                text: 'Are you sure you wish to delete this account group?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, continue',
                confirmButtonColor: '#E3342F',
                cancelButtonText: 'No, go back'
            })
                .then((selected) => {
                    if (selected.value) {
                        axios.delete(route('accountGroups.delete', this.group.id))
                            .then(response => {
                                this.$bus.$emit('alert.success', 'Account Group has been deleted')
                                this.$router.push({name: 'accountgroups.list'})
                            })
                            .catch((e) => {
                                console.dir({e})
                            })
                    }
                })
        },
        /**
         * Handle an [Escape] keypress
         *
         * @return {void}
         */
        onEscapeKeypress() {
            this.closeView()
        },
        /**
         * Show the Account Flags View
         */
        showFlagsView() {
            this.$router.push({name: 'accountGroups.flags', params: {id: this.group.id, flags: this.group.flags}})
        },
        /**
         * Navigate to the users search with a pre-filled search term
         * to display the members of this group
         *
         * @return {void}
         */
        handleViewUsers() {
            this.$root.persist.usersSearch = 'group:' + this.group.id
            this.$router.push({name: 'users.list'})
        },
    },
    watch: {
        //
    },
}
</script>

<style lang="less">
.account-sidebar {
    padding: 15px;
    width: 350px;
    font-size: 0.9rem;
    background: #f6f6f6;

    label {
        font-weight: bold;
        font-size: 0.8em;
        color: #999999;
    }

    p {
        margin-bottom: 0.5em;
    }
}

.account-activity {
    width: 250px;
    font-size: 0.9rem;
    padding: 15px;
}

.hidden-input {
    input {
        display: none;
        width: 100%;
    }

    .show {
        display: inline-block;
    }

    .hide {
        display: none;
    }

    .edit-field-link {
        text-decoration-line: underline;
        text-decoration-style: solid;
        color: #222222;
        word-wrap: break-word;
    }
}

.profile-form {
    .section-title {
        margin-top: 20px;
    }

    .form-title {
        margin-bottom: 20px;
    }
}
</style>
